/**
 * im启动器
 * Bai.Zhiming
 * 2019-8-5
 */
angular.module('imStarterModule', []).factory('imStarter', ['$rootScope', 'imService', 'messagePublishService', '$compile', '$templateRequest', 'modalDialog', '$q', 'loginService', '$controller', 'onGroupSystemNotifys', '$sessionStorage', 
    function($rootScope, imService, messagePublishService, $compile, $templateRequest, modalDialog, $q, loginService, $controller, onGroupSystemNotifys, $sessionStorage) {
        let currUserInfo, // 用户信息
            userSig, // 用户签名
            listeners = { // 监听方法
                onConnNotify(e) { // 用于监听用户连接状态变化的函数，选填
                    // debugger;
                },
                jsonpCallback(e) { // 用于 IE9（含）以下浏览器中 jsonp 回调函数,移动端可不填，PC 端必填
                    // debugger;
                },
                onMsgNotify(e) { // 监听新消息函数，必填
                    $rootScope.$broadcast('newMessage', e);
                },
                onBigGroupMsgNotify(e) { // 监听新消息(直播聊天室)事件，直播场景下必填
                    // debugger;
                },
                onGroupInfoChangeNotify(e) { // 监听群资料变化事件，选填

                },
                onGroupSystemNotifys: onGroupSystemNotifys,
                onKickedEventCall(e) {
                    destroyChatWindow();
                    modalDialog.alertType('您的im账号在其他页面登录，已经断开连接，是否重新连接？', '', 'ask', true, function() {
                        $rootScope.imReload();
                    }, () => {
                        $rootScope.isImReload = true;
                    });
                }
            },
            chatWindowController = {};

        /**
         * [imReload description] im重新登录方法
         * @return {[type]} [description]
         */
        $rootScope.imReload = function() {
            let deffer = $q.defer();
            imService.login(`${currUserInfo.TENANTID}_${currUserInfo.USERNAME}`, currUserInfo.TRUENAME, currUserInfo.USERHEAD, userSig, listeners)
                .then(() => {
                    $rootScope.chatLogonSuccess = true;
                    initChatWindow();
                    deffer.resolve();
                });
            return deffer.promise;
        };

        /**
         * [destroyChatWindow description] 销毁聊天窗口，通常是退出登录或被踢下线时调用
         * @return {[type]} [description]
         */
        function destroyChatWindow() {
            $rootScope.chatLogonSuccess = false;
            $rootScope.imChatList = [];
            chatWindowController.$scope.$destroy();
            chatWindowController.$element.remove();
        }

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            let deffer = $q.defer();

            messagePublishService.subscribe(
                'CurrLoginUserHaveGet',
                function (event, data) {
                    require(['imJson2', 'webim', 'sparkMd5'], (resp) => {
                        getCurrUserInfo().then(() => getUserSign()).then(() => imService.login(`${currUserInfo.TENANTID}_${currUserInfo.USERNAME}`, currUserInfo.TRUENAME, currUserInfo.USERHEAD, userSig, listeners)).then(() => {
                            imService.initRootScopeInfoMap(currUserInfo);
                        }).then(() => {
                            $rootScope.chatLogonSuccess = true;
                            initChatWindow();
                            imService.calibrationTime();
                            deffer.resolve();
                        });
                    });
                }
            );
            return deffer.promise;
        }

        /**
         * [getUserSign description]
         *
         * @return  {[type]}  [return description]
         */
        function getUserSign() {
            let deffer = $q.defer();
            imService.getUserSign(currUserInfo.USERNAME).then((resp) => {
                userSig = resp;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getCurrUserInfo description] 获取当前用户id
         * @return {[type]} [description]
         */
        function getCurrUserInfo() {
            let deffer = $q.defer();
            // if ($sessionStorage.get('curUserInfo')) {
            currUserInfo = $sessionStorage.get('curUserInfo');
            deffer.resolve($sessionStorage.get('curUserInfo'));
            // } else {
            //     loginService.getCurrLoginUser().then(function (data) {
            //         currUserInfo = data;
            //     });
            // }

            // let params = {
            //     serviceid: 'mlf_extuser',
            //     methodname: 'getCurrUserInfo',
            // };
            // trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
            //     .then((resp) => {
            //         currUserInfo = resp;
            //         deffer.resolve(resp);
            //     });
            return deffer.promise;
        }

        /**
         * [initChatWindow description] 初始化聊天窗口
         * @return {[type]} [description]
         */
        function initChatWindow() {
            getWindowTemplate().then((template) => {
                compileTemplate(template);
            });
        }

        /**
         * [compileTemplate description] 编译模板
         * @param  {[type]} template [description] 模板字符串
         * @param  {[object]} noticeInfo [description] 提醒内容
         * @return {[type]}          [description]
         */
        function compileTemplate(template) {
            let $template = $(template);
            chatWindowController.$scope = $rootScope.$new();
            chatWindowController.loginUser = currUserInfo;
            chatWindowController.$element = $template;
            $template = $compile($template)(chatWindowController.$scope);
            $('body').append($template);
            $controller('chatWindowCtrl', chatWindowController);
        }

        /**
         * [getWindowTemplate description]  获取弹窗模板
         * @return {[type]} [description]
         */
        function getWindowTemplate() {
            let deffer = $q.defer();
            $templateRequest('./IM/chatWindow/chatWindow_tpl.html').then((template) => {
                deffer.resolve(template);
            });
            return deffer.promise;
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {}
        return {

            /**
             * [start description] im启动
             * @return {[type]} [description]
             */
            start() {
                let deffer = $q.defer();
                initStatus().then(() => {
                    deffer.resolve();
                });
                initData();
                return deffer.promise;
            }
        };
    }
]);
